module.exports = __webpack_public_path__ + "img/position_list2.647ba5fa.png";